export interface Input {
  "on-zoom-in": () => void;
  "on-zoom-out": () => void;
}

<div class="map-zoom" key="map-zoom">
  <button class="zoom-control zoom-in" on-click("emit", "zoom-in")>
    <ebay-add-12-icon/>
  </button>
  <div class="separator"/>
  <button class="zoom-control zoom-out" on-click("emit", "zoom-out")>
    <ebay-remove-12-icon/>
  </button>
</div>
